import BiHubFooterLinks from 'components/Content/BeautyInsider/BiHubFooterLinks/BiHubFooterLinks.f';

export default BiHubFooterLinks;
